import React from 'react';
import { setProviderCookie } from '../../src/utils/referralProgram';
import LandingPage from '../../src/subkit-ui/subkit/LandingPage';
import ProviderReferralHeader from '../../src/components/TWProviderReferral/ProviderReferralHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;

var Wrapper = function Wrapper(_ref) {
  var referrerUser = _ref.referrerUser,
      shareCode = _ref.shareCode,
      currentUser = _ref.currentUser;

  if (referrerUser) {
    setProviderCookie({
      shareCode: shareCode,
      referrerUser: referrerUser
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [referrerUser && /*#__PURE__*/_jsx(ProviderReferralHeader, {
      referrerUser: referrerUser
    }), /*#__PURE__*/_jsx(LandingPage, {
      topBar: {
        buttonText: 'Get Started',
        buttonLink: '/beta-provider-signup'
      },
      header: {
        buttonText: 'Get Started',
        buttonLink: '/beta-provider-signup',
        title: 'Turn your craft into recurring revenue.',
        description: 'Our platform and team of experts will help you launch and grow your subscription business.'
      },
      imageHref: "/images/landing-plans.png",
      textAndImage: {
        imageHref: '/images/landing-plans-minor.png',
        title: 'Imagine that your email list, contacts, and followers are paying subscribers.',
        description: 'Our step-by-step playbooks will help you get to know your potential subscribers, figure out exactly what they want (and what they’re willing to pay for it), and build a “must have” subscription plan they’ll never cancel.'
      },
      checkmarkList: {
        title: 'It’s not just another tool — it’s the all-in-one tool.',
        listItems: ['Schedule in-person or virtual sessions with groups or 1-1, paid or free', 'Create subscription plans with flexible billing cycles, itemized features, and free trials', 'Set up two-sided referral programs for viral growth', 'Conduct surveys to iterate on your service and price better', 'Offer subscriber-only photos, videos, posts, and sessions', 'View your business health metrics in charts and learn how to improve']
      },
      testamonial: {
        text: '“I write about the philosophy of surfing. Subkit has helped me turn my email list into paying subscribers.”',
        name: 'Dion',
        jobTitle: 'Founder',
        companyHref: 'https://www.subkit.com/dion',
        companyName: 'Conatus Surfing Services',
        imageHref: '/images/landing-dion.jpg'
      },
      imageAndList: {
        title: 'Frequently Asked Questions',
        imageHref: '/images/landing-yelloworange.png',
        listItems: [/*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-lg md:text-xl mb-1 fw-700 text-gray-900",
            children: "How much does it cost?"
          }), /*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-gray-700",
            children: "Subkit is completely free until you make $500/month. At that point, it costs $39/month."
          })]
        }, "how-much"), /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-lg md:text-xl mb-1 fw-700 text-gray-900",
            children: "Does Subkit take a percentage of earnings?"
          }), /*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-gray-700",
            children: "No. We believe you should keep 100% of the money you make."
          })]
        }, "percentage"), /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-lg md:text-xl mb-1 fw-700 text-gray-900",
            children: "How long does it take to set up?"
          }), /*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-gray-700",
            children: "As little as 10 minutes \u2014 but in case you get stuck, we\u2019re always happy to help."
          })]
        }, "as-little"), /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-lg md:text-xl mb-1 fw-700 text-gray-900",
            children: "When will Subkit be available to the public?"
          }), /*#__PURE__*/_jsx("div", {
            className: "font-dmsans text-gray-700",
            children: "We\u2019re working hard to make the best product possible and won\u2019t make Subkit public until we\u2019re confident it's easy to use for all entrepreneurs."
          })]
        }, "available-to-public")]
      },
      callToAction: {
        title: 'Growing your business has never been easier with Subkit.',
        buttonLink: '/beta-provider-signup',
        buttonText: 'Get Started',
        smallText: 'Free until you’re making $500/month. $39/month after that.'
      }
    })]
  });
};

export default Wrapper;